<template>
  <w-modal
    :value="value"
    type="danger"
    width="544px"
    @close="$emit('input', false)"
  >
    <template #header>
      <h1>{{ title }}</h1>
    </template>
    <template #content>
      <div class="flex items-center">
        <i class="icon-alert-circle mr-4">
          <span class="path1" />
          <span class="path2" />
          <span class="path3" />
        </i>
        <slot name="content" />
      </div>
      <slot />
    </template>
    <template #footer>
      <div class="flex items-center justify-end">
        <w-button
          :disabled="loading"
          class="mr-6"
          color-type="error"
          type="link"
          @click="$emit('cancel')"
        >
          {{ cancelText }}
        </w-button>
        <w-button
          :disabled="loading"
          :loading="loading"
          color-type="error"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </w-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import MenuCommonDialog from './MenuCommonDialog';

export default MenuCommonDialog;
</script>

<style lang="scss" scoped>
@import 'MenuCommonDialog';
</style>
